import React, { useEffect, useState } from 'react';
import Corner from "./../corner1"; // Ensuring Corner is included
import { GiModernCity } from "react-icons/gi";
import { FaIndustry } from "react-icons/fa6";
import { GiFamilyHouse } from "react-icons/gi";

const CenteredBoxComponent = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Responsive styles dynamically calculated based on screen width
  const getResponsiveStyles = () => {
    if (windowWidth <= 480) {
      return {
        titleFontSize: "20px",
        subtitleFontSize: "18px",
        paragraphFontSize: "14px",
        centeredBoxWidth: "90%",
        flexDirection: "column",
        imageHeight: "300px",
        padding: "10px",
        verticalLineHeight: "130px",
      };
    } else if (windowWidth <= 768) {
      return {
        titleFontSize: "24px",
        subtitleFontSize: "20px",
        paragraphFontSize: "16px",
        centeredBoxWidth: "75%",
        imageHeight: "400px",
        padding: "20px",
        verticalLineHeight: "150px",
      };
    }
    return {
      titleFontSize: "28px",
      subtitleFontSize: "24px",
      paragraphFontSize: "18px",
      centeredBoxWidth: "40%",
      imageHeight: "500px",
      padding: "30px",
      verticalLineHeight: "200px",
    };
  };

  const styles = getResponsiveStyles();

  return (
    <div>
      {/* Headings & Introduction */}
      <h1 style={{ fontSize: styles.titleFontSize, fontWeight: "bold", marginTop: "50px", padding: styles.padding, textAlign: "center" }}>
        The Essence of Samson and Associates – 
        <span style={{ color: "#5c0e14" }}> Architectural & Interior Design Excellence</span>
      </h1>
      <h2 style={{ fontSize: styles.subtitleFontSize, fontWeight: "bold", color: "grey", padding: styles.padding, textAlign: "center" }}>
        Transformations and New Creations that Tend to Harmony
      </h2>
      <p style={{ fontSize: styles.paragraphFontSize, padding: styles.padding, textAlign: "center" }}>
        At Samson and Associates, we offer a comprehensive range of architectural, engineering, and interior design services 
        to transform your vision into reality.
      </p>

      {/* Image & Content Section */}
      <div style={{ position: "relative", width: "100%", opacity: 1, transform: "translateY(0)", transition: "opacity 0.8s ease-out, transform 0.8s ease-out" ,marginTop:"100px"}}>
        <div style={{ width: "100%", height: styles.imageHeight }}>
          <img
            src="https://img.freepik.com/free-photo/3d-rendering-modern-dining-room-living-room-with-luxury-decor_105762-2201.jpg"
            alt="Background"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        {/* Centered Info Box */}
        <div style={{
          position: "absolute",
          top: "27%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "white",
          padding: styles.padding,
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          zIndex: 10,
          width: styles.centeredBoxWidth,
          transition: "all 0.3s ease-in-out"
        }}>
          <h2 style={{ fontWeight: "bold", color: "#5c0e14" }}>Architectural Design</h2>
          <h3>Creating Iconic & Functional Spaces</h3>
          <p style={{ fontSize: styles.paragraphFontSize }}>
            Our architectural design services focus on aesthetic excellence, structural integrity, and sustainability.
          </p>
        </div>

        {/* Vertical Line (Now Responsive) */}
        <div style={{
          position: "absolute",
          top: "-5%",
          left: "50%",
          transform: "translateX(-50%)",
          width: "2px",
          height: styles.verticalLineHeight,
          background: "#5c0e14",
          zIndex: 20
        }}></div>

        {/* Two Columns Below the Image */}
        <div style={{ display: "flex", flexWrap: "wrap", flexDirection: styles.flexDirection, justifyContent: "space-between", alignItems: "flex-start", marginTop: "50px", padding: styles.padding }}>
          <div style={{ flex: "1", padding: styles.padding }}>
            {/* <Corner /> ✅ Added Corner */}
            <h2 style={{ fontWeight: "bold", color: "#5c0e14" }}>Pre-Design</h2>
            <h3 style={{ fontSize: styles.subtitleFontSize, color: "grey" }}>Programming and Existing Conditions</h3>
            <p style={{ fontSize: styles.paragraphFontSize }}>
              Our first steps will be getting to know each other, beginning to craft our understanding of the space.
            </p>
          </div>

          {/* Image Section */}
          <div style={{ flex: "1", display: "flex", flexDirection: "column", gap: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <GiModernCity style={{ width: "60px", height: "60px", borderRadius: "8px" }}/>
              <span>Modern & Sustainable Designs</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <GiFamilyHouse
                style={{ width: "60px", height: "60px", borderRadius: "8px" }}
              />
              <span>Bespoke Residential & Commercial Spaces</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <FaIndustry
                style={{ width: "60px", height: "60px", borderRadius: "8px" }}
              />
              <span>Urban & Industrial Planning</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenteredBoxComponent;
